module.exports = __webpack_public_path__ + "img/delete.24ec5f45.svg";